import React from 'react';
import { Box } from '@mui/material';
import Rating from '@mui/material/Rating';
import { syntheticEvent } from 'lib/utils';
import { Lens } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';

const RatingInput = ({
	value,
	label,
	name,
	handleChange,
	max = 5,
	size,
	...rest
}) => {
	const handleRatingChange = (event, newValue) => {
		let ev = syntheticEvent(newValue, name);
		handleChange(ev);
	};

	return (
		<div>
			<Typography component="legend">{label}</Typography>
			<StyledRating
				name={name}
				value={parseInt(value || 0)}
				onChange={handleRatingChange}
				max={max}
				size={size}
				icon={<Lens fontSize="inherit" />}
			/>
		</div>
	);
};

export default RatingInput;

const StyledRating = withStyles((theme) => ({
	iconFilled: {
		color: theme.palette.primary.main
	},
	iconHover: {
		color: theme.palette.primary.main
	}
}))(Rating);
